import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jsonConfig from '../../config/index.json';
import { useAxios } from '../../utils/hook/useAxios';
import DocumentUploader from '../DocumentUploader';

function AdminAnnonceItem({ data }) {
  const [CertificatImmat, setCertificatImmat] = useState(data?.Vehicle?.CertificatImmatriculation);
  const axios = useAxios();

  const [Assurance, setAssurance] = useState(data?.Vehicle?.Assurance);
  const [ControleTechnique, setControleTechnique] = useState(data?.Vehicle?.ControleTechnique);
  const [AutorisationProprietaire, setAutorisationProprietaire] = useState(
    data?.Vehicle?.AutorizationProprietaire
  );

  const [CertificatImmatriculationDoc, setCertificatImmatriculationDoc] = useState(
    data?.Vehicle?.CertificatImmatriculationDoc
  );

  const [AssuranceDoc, setAssuranceDoc] = useState(data?.Vehicle?.AssuranceDoc);
  const [ControleTechniqueDoc, setControleTechniqueDoc] = useState(
    data?.Vehicle?.ControleTechniqueDoc
  );

  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [uservehhicule, setUservehhicule] = useState({});

  useEffect(() => {
    const fetchVehicle = async () => {
      const response = await axios.get(`/api/vehicles/searchbyid/${data?.Vehicle?.id}`);
      if (response.data) {
        const v = response.data;
        setCertificatImmatriculationDoc(v.CertificatImmatriculationDoc);
        setAssuranceDoc(v.AssuranceDoc);
        setControleTechniqueDoc(v.ControleTechniqueDoc);
        setUservehhicule(v.UserProfile);
      }
    };
    fetchVehicle();
  }, [data?.Vehicle?.id]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const responseOption = await axios.get(`/api/vehicleOptionRecords/${data?.Vehicle?.id}`);
        if (responseOption.data) {
          setVehicleOptions(responseOption.data);
          setCertificatImmat(data?.Vehicle?.CertificatImmatriculation);
          setAssurance(data?.Vehicle?.Assurance);
          setControleTechnique(data?.Vehicle?.ControleTechnique);
          setAutorisationProprietaire(data?.Vehicle?.AutorizationProprietaire);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchOptions();
  }, [data]);

  const vehicleId = data?.Vehicle?.id;

  useEffect(() => {
    if (!vehicleId) return;

    const saveChecks = async () => {
      try {
        await axios.put(`/vehicles/${vehicleId}`, {
          CertificatImmatriculation: CertificatImmat ? 1 : 0,
          Assurance: Assurance ? 1 : 0,
          ControleTechnique: ControleTechnique ? 1 : 0,
          AutorizationProprietaire: AutorisationProprietaire ? 1 : 0,
        });
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };

    saveChecks();
  }, [vehicleId, CertificatImmat, Assurance, ControleTechnique, AutorisationProprietaire]);
  const km = [
    '0-15000 Km',
    '15-50 000 km',
    '50-100 000 Km',
    '100-150 000 km',
    '150-200 000 Km',
    '+200 000 km',
  ];

  function handleApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(
          `/vehicleAnnonces/` + data?.vehiculeAnnonceId + '/approve'
        );
        if (responseOption.data) {
          toast.success("L'annonce a été bien approuvée. Elle est maintenant en ligne");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  function handleAskDocument() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.post(`/ask-documents-vevicule`, uservehhicule);
        if (responseOption.data) {
          toast.success('Email envoyé avec succès');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  function handleSupprimer() {
    let Supprimer = async () => {
      try {
        const responseOption = await axios.put(
          `/vehicleAnnonces/` + data?.vehiculeAnnonceId + '/reject'
        );
        if (responseOption.data) {
          toast.success("L'annonce a été bien rejetée avec succès!");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Supprimer();
  }

  function handleDesactiver() {
    let Desactiver = async () => {
      try {
        const responseOption = await axios.put(
          `/vehicleAnnonces/` + data?.vehiculeAnnonceId + '/disable'
        );
        if (responseOption.data) {
          toast.success("L'annonce a été bien désactivée avec succès!");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Desactiver();
  }

  const uploadToCloudinary = async (file, setter) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'r6s4af83');

    const response = await fetch('https://api.cloudinary.com/v1_1/dtrkcpsky/auto/upload', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    setter(data.secure_url);
  };

  return (
    <>
      <ToastContainer />

      <div class="dashboard col-12">
        <div
          class="personal-data mb-4 bg-white shadow rounded-5 px-4 py-2 p-lg-4 aos animated aos-init aos-animate"
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
        >
          <div class="alert alert-warning" role="alert">
            L'autorisation du propriétaire est obligatoire uniquement si le nom dans le certificat
            d'immatriculation est sous un autre nom
          </div>
          <div className=" mb-3">
            <h3 className="mb-4">Documents du véhicule</h3>

            <DocumentUploader
              label="Certificat d'immatriculation (Carte grise)"
              docUrl={CertificatImmatriculationDoc}
              onUpload={(e) =>
                uploadToCloudinary(e.target.files[0], setCertificatImmatriculationDoc)
              }
            />

            <DocumentUploader
              label="Assurance du véhicule"
              docUrl={AssuranceDoc}
              onUpload={(e) => uploadToCloudinary(e.target.files[0], setAssuranceDoc)}
            />

            <DocumentUploader
              label="Contrôle technique"
              docUrl={ControleTechniqueDoc}
              onUpload={(e) => uploadToCloudinary(e.target.files[0], setControleTechniqueDoc)}
            />

            <button
              className="btn btn-primary btn-lg mt-3"
              onClick={async () => {
                await axios.put(`/vehicles/${data?.Vehicle?.id}`, {
                  CertificatImmatriculationDoc,
                  AssuranceDoc,
                  ControleTechniqueDoc,
                });
                alert('Documents enregistrés avec succès');
              }}
            >
              Enregistrer les documents
            </button>
          </div>

          <div class="title">
            <p class="lead me-auto">Validation de l'annonce</p>

            <button class="btn btn-danger ms-2" onClick={handleSupprimer}>
              Rejeter
            </button>
            <button class="btn btn-lg text-white ms-2" onClick={handleApprouver}>
              Approuver
            </button>
            <button class="btn btn-lg text-white ms-2" onClick={handleDesactiver}>
              Desactiver
            </button>
          </div>
          <div class="row">
            <div class="col-md-3 mb-3">
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setCertificatImmat(!CertificatImmat);
                  }}
                >
                  Certificat d'immatriculation (*){' '}
                  {CertificatImmat && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setAssurance(!Assurance);
                  }}
                >
                  Assurance (*) {Assurance && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setControleTechnique(!ControleTechnique);
                  }}
                >
                  Controle technique (*){' '}
                  {ControleTechnique && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setAutorisationProprietaire(!AutorisationProprietaire);
                  }}
                >
                  Autorisation du propriétaire (Facultatif){' '}
                  {AutorisationProprietaire && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>
              <Link to={'/admin/users/' + data?.Vehicle?.userId}>Details propriétaire</Link>
              <p className="text-muted">Liste des options</p>
              <ul>
                {vehicleOptions &&
                  vehicleOptions.map((option, index) => (
                    <li key={index}>{option.VehicleOption.name}</li>
                  ))}
              </ul>

              <br />
              <p className="text-muted">Caractéristiques Techniques</p>
              <ul>
                <li> {jsonConfig.porteNumber[data?.Vehicle?.porteNumber]} portes</li>
                <li> {jsonConfig.carburant[data?.Vehicle?.carburantType]}</li>
                <li>{jsonConfig.siegeNumber[data?.Vehicle?.siegeNumber]} places</li>
              </ul>
            </div>
            <div class="col-md mb-3">
              <div class="username mb-3">
                <label class="text-muted" for="username">
                  Modèle du véhicule et Marque
                </label>
                <input
                  id="username"
                  class="form-control"
                  type="text"
                  value={`${data?.Vehicle?.VehicleModel?.marque} model-${data?.Vehicle?.VehicleModel?.modele} `}
                  disabled=""
                />
              </div>
              <div class="order mb-3">
                <label class="text-muted" for="id_order">
                  Addresse de location
                </label>
                <input
                  id="id_order"
                  class="form-control"
                  type="text"
                  value=""
                  placeholder="56 Rue de la paix, 38000 Grenoble"
                />
              </div>
              <div class="order mb-3">
                <label class="text-muted" for="id_order">
                  Email du propriétaire
                </label>
                <input
                  id="id_order"
                  class="form-control"
                  type="text"
                  value={data?.Vehicle?.UserProfile?.email}
                  placeholder="salem@gmail.com"
                  disabled={true}
                />
              </div>
              <div class="content mb-3">
                <label class="text-muted" for="Content">
                  Immatriculation
                </label>
                <input
                  id="Immatriculation"
                  class="form-control"
                  type="text"
                  value={`${
                    data?.Vehicle?.UserProfile?.immatriculation
                      ? data?.Vehicle?.UserProfile?.immatriculation
                      : ''
                  }`}
                  placeholder="Immatriculation"
                />
              </div>
              <div class="content mb-3">
                <label class="text-muted" for="Content">
                  Kilométrage
                </label>
                <input
                  class="form-control"
                  type="text"
                  value={km[data?.Vehicle?.kilometrage]}
                  placeholder="Kilométrage"
                />
              </div>
              <div class="content mb-3">
                <label class="text-muted" for="Content">
                  Prix de l'annonce
                </label>
                <input
                  class="form-control"
                  type="text"
                  value={data?.reservationPrice + ' €'}
                  placeholder="Prix de l'annonce"
                />
              </div>
              <div class="reject mb-3">
                <label class="text-muted" for="Content">
                  Explication du rejet
                </label>
                <textarea
                  id="Content"
                  class="form-control autosize"
                  type="text"
                  value=""
                  rows="4"
                  style={{ height: '84px' }}
                ></textarea>
              </div>
              <div class="d-flex justify-content-between">
                <figure class="figure product_user">
                  <button type="button" class="btn-close" aria-label="Close"></button>
                  <img
                    class=""
                    src={data?.Vehicle?.images?.split(',')[0] || data?.Vehicle?.principalPhotos}
                    alt="user-avatar"
                    width={'160px'}
                    height={'160px'}
                  />
                </figure>
                <figure class="figure product_user">
                  <button type="button" class="btn-close" aria-label="Close"></button>
                  <img
                    class=""
                    src={data?.Vehicle?.images?.split(',')[1] || data?.Vehicle?.lateralPhotos}
                    alt="user-avatar"
                    width={'160px'}
                    height={'160px'}
                  />
                </figure>
                <figure class="figure product_user">
                  <button type="button" class="btn-close" aria-label="Close"></button>
                  <img
                    class=""
                    src={data?.Vehicle?.images?.split(',')[2] || data?.Vehicle?.interiorPhotos}
                    alt="user-avatar"
                    width={'160px'}
                    height={'160px'}
                  />
                </figure>
              </div>
              <button class="btn btn-lg ms-2 text-white" onClick={handleAskDocument}>
                Demander les documents requis
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminAnnonceItem;
